import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Boutique, BoutiqueItems, SupplyOrders, SupplyItems, CustomerOrders } from '../types';

interface BoutiquesState {
    boutiques: Boutique[];
    boutiqueItems: BoutiqueItems[];
    supplyOrders: SupplyOrders[];
    supplyItems: SupplyItems[];
    customerOrders: CustomerOrders[];
}

const initialState: BoutiquesState = {
    boutiques: [],
    boutiqueItems: [],
    supplyOrders: [],
    supplyItems: [],
    customerOrders: []
};

const boutiquesSlice = createSlice({
    name: 'boutiques',
    initialState,
    reducers: {
        setBoutiques: (state, action: PayloadAction<Boutique[]>) => {
            state.boutiques = action.payload;
        },
        setBoutiqueItems: (state, action: PayloadAction<BoutiqueItems[]>) => {
            state.boutiqueItems = action.payload;
        },
        updateBoutiqueItem: (state, action: PayloadAction<BoutiqueItems>) => {
            const index = state.boutiqueItems.findIndex(
                (item) => item.boutiqueItemId === action.payload.boutiqueItemId
            );
            if (index !== -1) {
                state.boutiqueItems[index] = action.payload;
            }
        },
        setSupplyOrders: (state, action: PayloadAction<SupplyOrders[]>) => {
            state.supplyOrders = action.payload;
        },
        setSupplyItems: (state, action: PayloadAction<SupplyItems[]>) => {
            state.supplyItems = action.payload;
        },
        setCustomerOrders: (state, action: PayloadAction<CustomerOrders[]>) => {
            state.customerOrders = action.payload;
        }
    }
});

export const { 
    setBoutiques, 
    setBoutiqueItems,
    updateBoutiqueItem,
    setSupplyOrders, 
    setSupplyItems, 
    setCustomerOrders 
} = boutiquesSlice.actions;

export default boutiquesSlice.reducer; 